var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-size-page-layout',[_c('form-card-alive-check',{ref:"aliveCheck",staticClass:"max-w-2xl mx-auto",on:{"alive":_vm.handleTryAgain}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }